export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img
              src="https://res.cloudinary.com/dbgzzcwvr/image/upload/v1756632676/about_mzaiij.png"
              className="img-responsive about-img"
              alt="Netra Bharat Industries"
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>
                Netra Bharat Industries Pvt. Ltd. is a growing Indian consumer
                products company focused on product development, brand building,
                sourcing, quality assurance, and distribution. We develop and
                supply reliable products for homes and businesses across India
                and international markets.
              </p>
              <p>
                Our current focus is kitchenware, cookware, pressure cookers
                and gas stoves — supplied through our brand <strong>Utensy</strong> to
                dealers, distributors, wholesalers, exporters and institutional
                buyers. Our upcoming consumer brand <strong>MrUtensy</strong> will bring
                the same quality directly to end consumers through Amazon,
                Flipkart and direct channels.
              </p>
              <p>
                Long-term, we are building a multi-brand, multi-category
                consumer products company — expanding into home appliances,
                household products and other consumer categories over time.
              </p>

              <h3>What We Do</h3>
              <ul className="list-style">
                {props.data
                  ? props.data.coreFocus.map((item, i) => <li key={i}>{item}</li>)
                  : null}
              </ul>

              <div className="about-stats-row">
                {[
                  { num: "30+",       label: "Product Variants" },
                  { num: "5+",        label: "Categories" },
                  { num: "Pan-India", label: "Distribution" },
                ].map((s, i) => (
                  <div key={i} className="about-stat">
                    <div className="about-stat-num">{s.num}</div>
                    <div className="about-stat-label">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
